import * as React from "react";
import { ZIndexContext } from "../managers/ZIndexManager";

function useZIndex(id: string) {
  const [index, setIndex] = React.useState<number>(null as any);

  const { subscribe, unsubscribe } = React.useContext(ZIndexContext);
  React.useEffect(() => {
    setIndex(subscribe(id));
    return () => {
      unsubscribe(id);
    };
  }, []);

  return index;
}

export default useZIndex;
